import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { EMPTY, Observable, of } from "rxjs";

declare global {
	// eslint-disable-next-line no-var
	var isDOMSSR: boolean | undefined;
}

@Injectable({
	providedIn: "root",
})
export class PlatformService {
	/**
	 * Returns whether the app is running in the browser.
	 *
	 * **Note**: this will be false when the user is using the mobile wrapper app. If you want to target both of those platforms, use **!isServer** instead.
	 */
	readonly isBrowser = isPlatformBrowser(this.platformId);
	readonly isServer = isPlatformServer(this.platformId) || !!globalThis.isDOMSSR;

	constructor(@Inject(PLATFORM_ID) private platformId: object) {}

	forClient<T>(observableFactory: () => Observable<T>, fallbackObservable?: T): Observable<T> {
		return this.isBrowser && !globalThis.isDOMSSR
			? observableFactory()
			: fallbackObservable === undefined
				? EMPTY
				: of(fallbackObservable);
	}

	forServer<T>(observableFactory: () => Observable<T>): Observable<T> {
		return this.isServer || globalThis.isDOMSSR ? observableFactory() : EMPTY;
	}
}
